export const ICON_WIDTH = 45;
export const PLACEHOLDER_TEXT_FOR_IMG_INSERT = "{{logo}}";

export const CLOSE_ICON = {
    color: "#F0F0F5",
    fill: "#616469",
    size: 28,
};

export const PLUS_ICON = {
    fill: "#02060ceb",
    size: 12,
};

export const ACCESSIBILITY_TEXTS = {
    GO_BACK_TO_CART: "Go back to cart",
};
